import { Outlet } from 'react-router-dom'

const CampaignEvent = () => <Outlet />

export default CampaignEvent
